import React, { createContext, useState, useEffect } from "react";

export const CurrencyContext = createContext();

export const CurrencyProvider = ({ children }) => {
  const [currency, setCurrency] = useState("INR");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [exchangeRate, setExchangeRate] = useState(null);
  const fetchRate = async () => {
    const res = await fetch("https://api.exchangerate-api.com/v4/latest/INR");
    const data = await res.json();
    setExchangeRate(data.rates.USD);
  };

  useEffect(() => {
    const storedCurrency = localStorage.getItem("currency");
    if (!storedCurrency) {
      setIsModalOpen(true);
    } else {
      setCurrency(storedCurrency);
    }
    fetchRate();
  }, []);

  useEffect(() => {
    if (isModalOpen) {
      document.body.classList.add("no-scroll");
    } else {
      document.body.classList.remove("no-scroll");
    }

    // Cleanup on component unmount
    return () => {
      document.body.classList.remove("no-scroll");
    };
  }, [isModalOpen]);

  const handleLocationSelect = (location) => {
    const selectedCurrency = location === "India" ? "INR" : "USD";
    setCurrency(selectedCurrency);
    localStorage.setItem("currency", selectedCurrency);
    window.location.reload();
  };

  const convertPrice = (priceInINR) => {
    if (currency === "USD" && exchangeRate) {
      return (priceInINR * exchangeRate).toFixed(2);
    }
    return priceInINR;
  };

  const getCurrencySymbol = () => (currency === "INR" ? "₹" : "$");

  return (
    <CurrencyContext.Provider
      value={{
        currency,
        setCurrency,
        isModalOpen,
        setIsModalOpen,
        handleLocationSelect,
        convertPrice,
        getCurrencySymbol,
      }}
    >
      {children}
    </CurrencyContext.Provider>
  );
};
